import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { CommitteeDecisionComment, CommitteeMeeting, CommitteeMeetingDecision, CommitteeMeetingsListResponse } from '../models/meetings';
import { ActionShareholder } from 'modules/main/actions/commonModels';
import { CommitteeAttendee, CommitteeAttendeesListResponse } from '../models/attendance';
import { CommitteeMember } from '../models/members';

export const onGetCommitteeMeetingsList = async (committeeId: number, page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<CommitteeMeetingsListResponse>>(`dashboard/committees/${committeeId}/meetings`, {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetCommitteeMeetingById = async (committeeId: string, id: string) => {
	try {
		const response = await axios.get<JsonResponse<CommitteeMeeting>>(`dashboard/committees/${committeeId}/meetings/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreateCommitteeMeeting = async (committeeId: string, payload: FormData) => {
	try {
		const response = await axios.post<JsonResponse<CommitteeMeeting>>(`dashboard/committees/${committeeId}/meetings`, payload);
		return response.data.success;
	} catch (error) {
		throw error;
	}
};

export const onUpdateCommitteeMeeting = async (committeeId: string, id: string, payload: FormData) => {
	try {
		const response = await axios.post<JsonResponse<CommitteeMeeting>>(`dashboard/committees/${committeeId}/meetings/${id}`, payload);
		return response.data.success;
	} catch (error) {
		throw error;
	}
};

export const onCancelCommitteeMeeting = async (committeeId: string, meetingId: number) => {
	try {
		const response = await axios.post(`dashboard/committees/${committeeId}/meetings/${meetingId}/cancel`);
		return response.data.success;
	} catch (error) {
		throw error;
	}
};

export const onStartCommitteeMeetingVoting = async (committeeId: number, meetingId: number) => {
	try {
		const response = await axios.post(`dashboard/committees/${committeeId}/meetings/${meetingId}/start-voting`);
		return response.data.success;
	} catch (error) {
		throw error;
	}
};

export const onStartCommitteeMeetingAttendance = async (committeeId: number, meetingId: number) => {
	try {
		const response = await axios.post(`dashboard/committees/${committeeId}/meetings/${meetingId}/open-attendance`);
		return response.data.success;
	} catch (error) {
		throw error;
	}
};

export const onGetCommitteeMeetingAttendees = async (committeeId: string, id: string, page: number) => {
	try {
		const response = await axios.get<CommitteeAttendeesListResponse>(`dashboard/committees/${committeeId}/meetings/${id}/attendees`, {
			params: { page },
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const onGetCommitteeMeetingAttendeeById = async (committeeId: string, id: string, attendeeId: number) => {
	try {
		const response = await axios.get<JsonResponse<{ attendance: CommitteeAttendee }>>(
			`dashboard/committees/${committeeId}/meetings/${id}/attendees/${attendeeId}`,
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSearchCommitteeShareholder = async (committeeId: string, id: string, keyword: string) => {
	try {
		const response = await axios.get<JsonResponse<ActionShareholder[]>>(`dashboard/committees/${committeeId}/meetings/${id}/attendees/search`, {
			params: { keyword },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onAddCommitteeAttendee = async (committeeId: string, meetingId: string, board_member_id: string) => {
	try {
		const response = await axios.post<JsonResponse<ActionShareholder[]>>(
			`dashboard/committees/${committeeId}/meetings/${meetingId}/attendees`,
			{ board_member_id },
			{},
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetCommitteeMeetingDecisions = async (committeeId: string, meetingId: string) => {
	try {
		const response = await axios.get<JsonResponse<{ decisions: CommitteeMeetingDecision[]; decisions_comments_footer: string | null }>>(
			`dashboard/committees/${committeeId}/meetings/${meetingId}/decisions/comments`,
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onAddCommitteeMeetingVote = async (committeeId: string, meetingId: string, payload: FormData) => {
	try {
		const response = await axios.post(`dashboard/committees/${committeeId}/meetings/${meetingId}/add-vote`, payload, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onEndCommitteeMeetingVoting = async (committeeId: string, meetingId: number) => {
	try {
		const response = await axios.post(`dashboard/committees/${committeeId}/meetings/${meetingId}/end-voting`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCloseCommitteeMeeting = async (committeeId: string, meetingId: number) => {
	try {
		const response = await axios.post(`dashboard/committees/${committeeId}/meetings/${meetingId}/complete`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onAddCommitteeMeetingDecisionComments = async (committeeId: string, meetingId: string, comments: CommitteeDecisionComment[],decisions_comments_footer: string) => {
	try {
		const response = await axios.put(`dashboard/committees/${committeeId}/meetings/${meetingId}/decisions/comments-bulk`, { comments, decisions_comments_footer });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSearchCommitteeMember = async (search: string) => {
	try {
		const response = await axios.get<JsonResponse<CommitteeMember[]>>(`dashboard/meetings/board-members`, { params: { search } });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onPublishCommitteeMeeting = async (committeeId: string, meetingId: number) => {
	try {
		const response = await axios.post(`dashboard/committees/${committeeId}/meetings/${meetingId}/publish`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
